import { ToolkitListingID, isUndefined } from '@aloft/toolkit-shared';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { useToolkitContext } from '../../../hooks/api/toolkitContext.js';
import { useToolkitControllerGlobal } from '../useToolkitControllerGlobal.js';
import { ListingResult } from './types.js';

export function useGetListing(
  listingID: ToolkitListingID | undefined,
  disabled = false,
): UseQueryResult<ListingResult> {
  const { fetcherOptions } = useToolkitContext();
  const { mlsListingsBatcher } = useToolkitControllerGlobal();
  return useQuery(
    ['AbodeListing', listingID ?? 'missing_listing'],
    async () => {
      return isUndefined(listingID)
        ? { status: 'missing' }
        : mlsListingsBatcher.fetch(listingID, fetcherOptions);
    },
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      enabled: !disabled,
    },
  );
}
